export default __webpack_public_path__ + "static/media/landing-hero.e0644a06.png";